export default {
    menu: {
        home: '首页',
        product: '产品介绍',
        about: '公司简介',
        login: '登入',
        register: '注册'
    },
    action: {
        switchLanguage: '语言切换成功'
    }
}
